<template>
  <div class="main">
    <dd-header></dd-header>
    <div>プランニング</div>
    <section id="noinfo_sheet" class="print_view page-always" >
      <h3 id="title">提案プラン</h3>
      <dd-sheet
        ref="sheetModalRef"
        :spaceJoincd="spaceJoincd"
        :isPreview=false
        @showModal="delayShowModal"
      />
    </section>
    <dd-footer></dd-footer>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../utils/App'
import * as Api from '../utils/Api'
import {DC_URL} from '../constants/App'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Sheet from '../components/order/Sheet'

export default {
  name: 'Top',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-sheet': Sheet
  },
  data () {
    return {
      cid: 0,
      svgWidth: '100%',
      svgHeight: '100%',
      spaceJoincd: undefined
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getSketchResource(image)
    },
    planning: function () {
      // let payload = {
      //   params: {
      //     orderCode: this.planId
      //   }
      // }
      console.log('start planning')
      // axios.get(DC_URL.SKETCH + '/planning', payload
      axios.get(DC_URL.SKETCH + '/planning'
      ).then(response => {
        this.spaceJoincd = response.data.data.spaceJoincd
        console.log('space join code2 = ' + this.spaceJoincd)
        this.$refs.sheetModalRef.getSheet()
      }).catch(error => {
        Api.handleError(error)
      })
    },
    delayShowModal: function () {
      // 図面が完成してから表示
      this.$nextTick(function () {
        // if (!Check.isBrawserIE()) return
        let modalWidth = document.getElementById('estimate_main').clientWidth
        let modalHeight = document.getElementById('estimate_main').clientHeight
        // 親領域のpadding、右のスクロールバーを引く
        this.svgWidth = (modalWidth - 20 - 20) + 'px'
        this.svgHeight = modalHeight * 0.6 + 'px'
        console.log('next tick end')
      })
    },
    guestLogin: async function () {
      console.log('guest login')
      this.$refs.loadingModalRef.showModal(true)
      await axios.get(DC_URL.LOGIN + '/guest')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.userInfo = response.data.data
            console.log('set guest user:' + Object.entries(this.userInfo))
            // App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, this.userInfo)
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    syncLogin: async function () {
      await this.guestLogin()
    }
  },
  mounted () {
  },
  created () {
    this.syncLogin()
    this.planId = this.$route.query.planId
    this.planning()
  }
}
</script>



// WEBPACK FOOTER //
// src/main/js/pages/Planning.vue